import { distinctUntilChanged, map, Observable, of, switchMap, timer } from 'rxjs';

// ensures that loading state stays true for at least provided minimum duration
export function holdTrueForMinimum(minDuration = 600) {
  let startTime = 0;

  return (source$: Observable<boolean>): Observable<boolean> =>
    source$.pipe(
      distinctUntilChanged(),
      switchMap(isLoading => {
        if (isLoading) {
          startTime = Date.now();
          return of(true);
        } else {
          const elapsed = Date.now() - startTime;
          const remaining = minDuration - elapsed;
          return remaining > 0 ? timer(remaining).pipe(map(() => false)) : of(false);
        }
      })
    );
}

// ensures that promise resolves only after provided minimum duration
export async function ensureMinimumTime<T>(promise: Promise<T>, minDuration = 600): Promise<T> {
  const start = Date.now();
  const result = await promise;
  const elapsed = Date.now() - start;
  const remaining = minDuration - elapsed;
  if (remaining > 0) {
    await new Promise(resolve => setTimeout(resolve, remaining));
  }
  return result;
}
